/**
 * 精确匹配 Go url.QueryEscape 行为：
 * 空格 -> '+'
 * 未编码集合仅为 A-Za-z0-9 - _ . ~（比 encodeURIComponent 多编码 ! * ' ( )）
 */
function goQueryEscape(str) {
  return encodeURIComponent(str)
    .replace(/%20/g, "+")
    .replace(
      /[!'()]/g,
      (c) => "%" + c.charCodeAt(0).toString(16).toUpperCase(),
    );
}

/**
 * 将对象转为 Map，所有数字值转为字符串（保留原始格式）
 * 对应 Go: CommonStructToMap
 */
export function commonStructToMap(obj) {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === "number") {
      result[key] = Number.isInteger(value) ? String(value) : String(value);
    } else {
      result[key] = value;
    }
  }
  return result;
}

/**
 * 生成签名（SHA256）
 * 对应 Go: CommonMakeSign
 * @param {Object} params - 签名参数
 * @param {string} signKey - 签名密钥
 * @returns {Promise<string>} 十六进制 SHA256 签名
 */
export async function commonMakeSign(params, signKey) {
  // 1. 移除不参与签名的字段
  const p = { ...params };
  delete p.sign;
  delete p.service;
  delete p.s;

  // 2. 键值对，值统一转字符串
  const kvs = Object.entries(p).map(([key, value]) => ({
    key,
    value: String(value),
  }));

  // 3. 按 key 降序排序
  kvs.sort((a, b) => (b.key > a.key ? 1 : b.key < a.key ? -1 : 0));

  // 4. 构建查询字符串，追加 signKey
  const parts = kvs.map(
    ({ key, value }) => `${goQueryEscape(key)}=${goQueryEscape(value)}`,
  );
  const signString = parts.join("&") + "&" + signKey;

  // 5. SHA256 -> 十六进制
  const encoded = new TextEncoder().encode(signString);
  const hashBuffer = await crypto.subtle.digest("SHA-256", encoded);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

/**
 * 获取当前环境的 signKey
 */
export function getSignKey() {
  return "WKkQfgKSH4Sg6jQ@u1Me43QfxFD"; // 生产环境
  //  return '0cIeoU44@yAfKkeptmXEeHd';       // 测试环境
}
